import '@stimulus/polyfills';
import { Application } from '@stimulus/core';
import { definitionsFromContext } from '@stimulus/webpack-helpers';
const application = Application.start();
const context = require.context('../controllers', true, /\.(js|ts)$/);
application.load(definitionsFromContext(context));
